// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebook .title,
.shop-section .title {
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    /* gap: 20px; */
    justify-content: space-between;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 40px 0px 10px 0px;
}

.ebook .hdivider,
.shop-section .hdivider,
.otherbooks .hdivider {
    transform: scaleY(0.5);
}

.ebook .year-wise,
.ebooks-one-year .month-wise {
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* 4 items per row */
    gap: 30px;
}

.ebook .year-wrapper,
.ebooks-one-year .month-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ebook .year-wrapper img,
.ebooks-one-year .month-wrapper img {
    width: 9rem;
    height: 10rem;
    object-fit: cover;
}

.ebook .year-wrapper button,
.ebooks-one-year .month-wrapper button {
    margin: 0 !important;
}

.Year-navigation,
.Month-navigation,
.category-navigation,
.home-navigation {
    display: inline-flex;
    gap: 5px;
    padding: 10px 0;
    font-size: 12px;
    cursor: pointer;
}

.Month-navigation>.month,.year,
.category-navigation>.nav-book,
.home-navigation>.nav-title {
    color: #D58C19;
    font-weight: 600;
}

.monthlybook-buysection,
.categorybook-buysection,
.book-navigator {
    display: flex;
}

.monthlybook-buysection,
.categorybook-buysection {
    gap: 20px;
}

.prev-next,
.prev,
.nxt {
    display: inline-flex;
}

.prev,
.nxt {
    cursor: pointer;
}

.book-navigator {
    justify-content: space-between;
}

.img-details-section {
    display: flex;
    align-items: flex-start;
    gap: 3%;
    justify-content: center;
    margin-top: 1rem;
    @media screen and (max-width: 430px) {
        flex-direction: column;
        align-items: center;
        
    }
}

.img-details-section img {
    width: 25vw;
    @media screen and (max-width: 430px) {
        width: 100%;
    }
}

.img-details-section>.details {
    padding-top: 1rem;
    width: 50%;
    line-height: 1.7;
    @media screen and (max-width: 430px) {
        width: 100%;
        text-align: justify;
        font-size: 14px;
        
    }
}

.audio-section {
    padding: 5%;
    border: 1px solid #E7E7E7;
    box-shadow: #000000;
    /* box-shadow: 0px 4px 4px 0px #00000040; */
}

.audio-section>.audio-cat {
    display: inline-flex;
    /* background: #F09300; */
    padding: 2px;
    width: 5vw;
    justify-content: flex-start;
    font-size: 0.8rem;
    color: #000000;
    line-height: 20px;
    width: 100%;
}

.audio-section>.audio-subtext {
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 0.8rem;
    line-height: 20px;
}

.audio-section .views {
    display: flex;
    gap: 2px;
}

.audio-title-section {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
}

.audio-title-section>.audio-title {
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: -2px;
}
@media (max-width: 435px) {
    .audio-title-section>.audio-title {
        font-size: 1.1rem;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -2px;
    }
}

.audio-title-section button {
    cursor: pointer;
    padding: 0 15px;
    border: none;
    border-radius: 80px;
    color: #ffffff;
    font-weight: 700;
    font-size: 0.8rem;
    line-height: 44px;
}
@media (max-width: 435px){
    .audio-title-section button {
        cursor: pointer;
        padding: 0 10px;
        border: none;
        border-radius: 80px;
        color: #ffffff;
        font-weight: 700;
        font-size: 0.7rem;
        line-height: 24px;
    }
}

.audio-play-title {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}

.audio-play-title>.index {
    padding: 8px 12px;
    /* border: 1px solid #000000; */
    background: rgba(240, 170, 0, 0.5);
    border-radius: 50px;
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 500;
}
@media (max-width: 435px){
    .audio-play-title>.index{
        padding: 5px 8px;
        font-size: 0.7rem;
        white-space: nowrap;
    }
}

.audio-play-title p {
    color: #11151F;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

}
@media (max-width: 435px){
    .audio-play-title p{
        font-size: 12px;
        line-height: 14px;
    }
}

.audio-play-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 30px;

}

.audio-play-section .player-transcript-section p {
    background-color: #FFFFFF;
}

.audio-play-section .player {
    /* border: 1px solid #ddd; */
    border-radius: 10px;
    padding: 20px;
    max-width: 900px;
    margin: 20px auto;
    background-color: #fff;
    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.audio-play-section .audio-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    @media screen and (max-width: 430px) {
        flex-direction: column;
        /* align-items: flex-start; */
        
    }
}

.audio-play-section .audio-image {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-right: 15px;
}

.audio-play-section .audio-details {
    flex: 1 1;
}

.audio-play-section .audio-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1rem;
    color: #11151f;
}

.audio-play-section .audio-author {
    margin: 5px 0 0;
    font-size: 14px;
    color: #555;
}

.audio-play-section .audio-element {
    width: 100%;
    margin: 10px 0;
}

.audio-play-section .audio-transcript {
    font-size: 0.8rem;
    line-height: 20px;
    color: #000000;
    font-weight: 400;
    text-align: justify;
    max-height: 200px; /* Set a max height for the transcript */
    overflow-y: auto; /* Make it scrollable when the content exceeds the height */
    padding-right: 10px;
}

.audio-prev-nxt {
    display: flex;
    justify-content: space-between;
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: #E6E6E6;
    padding: 10px 0;
}

.audio-prev,
.audio-nxt {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
}

.audio-prev,
.audio-nxt img {
    max-width: 5vw;
}

.audio-prev-text,
.audio-nxt-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.audio-nxt-text .nxt,
.audio-prev-text .prev {
    color: #999999;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 20px;
}

.prev-title,
.nxt-title {
    color: #000000;
    font-size: 1rem;
    font-weight: 600;
    line-height: 24px;
}

.monthlybook-buysection>.book-imagesection,
.categorybook-buysection>.book-imagesection {
    width: 40%;
}

.monthlybook-buysection>.book-contentsection,
.categorybook-buysection>.book-contentsection {
    width: 50%;
}

.monthlybook-buysection>.book-imagesection img,
.categorybook-buysection>.book-imagesection img {
    width: 100%;
}

.prev-next {
    gap: 10px;
}
.other-ebooks{
    display: flex;
    flex-direction: row;
    gap: 15px;
    padding: 20px 0
}

.other-ebook-subtext,.comments-views, .other-book-desc{
    color: #999999;
    font-size: 0.8rem;
    line-height: 14px;
    font-weight: 400;
}
.other-book-desc{
    padding-bottom: 10px;
}
.comments-views{
    display: inline-flex;
    gap: 2px;
    align-items: center;
}
.comments-views> .comments, .comments-views>.views{
    display: inline-flex;
    gap: 2px;
    align-items: center;
}
.other-book-title{
    font-size: 1rem;
    font-weight: 600;
    line-height: 24px;
    color: #000000;
}
.other-book-cat-read-more{
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #E6E6E6;
    padding-top: 10px;
}
.other-book-cat{
    font-size: 12px;
    font-weight: 400;
    line-height: 13.66px;
    text-align: left;
}
.other-book-cat span{
    color:#f09300
}
.other-book-read-more{
    font-size: 12px;
    font-weight: 600;
    line-height: 12.29px;
    text-align: left;
    color: #000000;
}


.monthlybook-buysection .title-section,
.categorybook-buysection .title-section {
    padding-top: 15px;
}

.monthlybook-buysection .title,
.categorybook-buysection .title {
    font-size: 2rem;
}

.monthlybook-buysection .subtext,
.categorybook-buysection .subtext {
    padding: 10px 0;
    font-size: 0.8rem;
    gap: 20px;
    border-bottom: 1px solid #E6E6E6;
    font-weight: 100;
}

.monthlybook-buysection .subtext>.author,
.categorybook-buysection .subtext>.author {
    padding-right: 20px;
    border-right: 1px solid #E6E6E6;
}

.book-contentsection .shortdesc {
    padding: 15px 0;
    color: #444444;
    font-size: 0.8rem;
    font-weight: 100;
}


.tabs,
.buttons {
    display: flex;
    gap: 10px;
    margin: 10px 0;
}

.buttons button {
    font-size: 0.8rem;
}

.desc-info-tabs {
    display: flex;
    justify-content: start;
    gap: 5lvw;
}

.desc-info-tabs>button {
    font-size: 1.2rem;
    border: none;
}

.tab-button,
.desc-info-tabs .tab-underscore {
    padding: 5px;
    background-color: white;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 100;
    line-height: 20px;
}

.tab-button {
    border-radius: 10px;
    border: 2px solid #ccc;
}

.tab-button.active {
    color: #000000;
    border-color: #F09300;
}

.tab-content {
    margin-top: 20px;
    border-radius: 10px;
    width: 100%;
    background-color: #f9f9f9;
}

.tab-content .hardcopy,
.category-buy-section .tab-content {
    font-size: 1rem;
    font-weight: 400;
}

.audio-buy .plans {
    font-size: 1rem;
    padding-bottom: 15px;
}

.audio-buy .plans a {
    color: #F09300;
    text-decoration: underline;
    cursor: pointer;
}

.listen-copy-buy-section,
.category-buy-section {
    font-size: 0.8rem;
    color: #444444;
    font-weight: 100;
}

.subscribe-section {
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: #E6E6E6;
    padding: 10px 0;
}

.subscribe-section button {
    margin: 0 !important;
}

.cat-tag {
    padding: 10px 0;
    font-size: 0.6rem;
    font-weight: 100;
    line-height: 24px;
}

.month-selection,
.year-selection {
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.month-selection label,
.year-selection label {
    white-space: nowrap;
    font-size: 1rem;
    font-weight: 100;
    line-height: 20px;
}

.month-selection input,
.year-selection input {
    width: 4rem;
    padding: 0.4rem;
    font-size: 1.2rem;
    text-align: center;
    border: 1px solid #E6E6E6;
    border-radius: 50px;
}

.month-selection input[type="number"]:hover,
.year-selection input[type="number"]:hover {
    border-color: #007BFF;
}

.quantity-select {
    padding: 10px 0;
    display: flex;
    align-items: flex-end;
    gap: 20px;
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: #E6E6E6;
}

.quantity-select button {
    margin: 0 !important;
}

.quantity-select .counter {
    display: inline-flex;
    gap: 20px;
    font-size: 1rem;
    border: 1px solid #E6E6E6;
    border-radius: 50px;
    padding: 10px;
}

.note {
    font-size: 0.6rem;
    padding-bottom: 10px;
}

.note span {
    color: #E2401C;
}

.counter>.increase,
.decrease {
    cursor: pointer;
}

.tab-underscore.active {
    color: #000000;
    /* border-bottom: 2.5px solid #F09300; */
}

.desc-tab-content>* {
    /* padding: 20px 10%; */
    font-size: 0.8rem;
    font-weight: 100;
    color: #444444;
    display: flex;
    flex-wrap: wrap;
    line-height: 24px;
}

.otherbooks-title {
    display: flex;
    gap: 50px;
    color: #000000;

}

.otherbooks-title .hdivider {
    color: #E6E6E6;
}

.otherbooks-title .text {
    font-size: 1.4rem;
    font-weight: 100;
}

.otherbooks-title .hdivider img {
    width: 100%;
    filter: invert(88%) sepia(11%) saturate(0%) hue-rotate(0deg) brightness(91%) contrast(93%);
}

.book-cards {
    /* padding: 20px 0; */
    display: flex;
    gap: 20px;
    flex-direction: row;
    justify-content: flex-start;
}

.book-card,
.cat-book-card {
    width: 10vw;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

}

.cat-book-card {
    border-right: 1px solid #E6E6E6;
}

.book-card .text,
.cat-book-card .text {
    font-size: 0.7rem;
    font-weight: 100;
    line-height: 24px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: block;
}

.book-card img,
.cat-book-card img {
    width: 100%;
}

.book-card button,
.cat-book-card button {
    cursor: pointer;
    border: none;
    color: #F09300;
    font-weight: 700;
    font-size: 1.2rem;
    background: none;
    padding: 0;
}

.shop-section .genre {
    flex: 1 1;
}

.shop-section .buy-section {
    flex: 4 1;
}

.shop-section .genre .MuiCardContent-root {
    display: flex;
    font-size: 0.8rem;
    flex-direction: column;
    color: #0A0A0A;
    gap: 30px;
}

.shop-section .categ {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.shop-section .categ .text {
    color: #444444;
    font-size: 0.8rem;
    font-weight: 400;
}

.shop-section .categ {
    display: flex;
    flex-direction: row;
    gap: 10px;
    cursor: pointer;
}

.shop-section .categ input[type="checkbox"] {
    accent-color: black;
}

.shop-section .title {
    color: #000000;
    font-size: 1.2rem;
    font-weight: 600;
}

.shop-section .content-section>* {
    margin-bottom: 10px;
}

.shop-section .subtitle,
.shop-section .desc {
    font-size: 1rem;
    font-weight: 100;
    color: #444444;
}

.shop-section .price {
    font-size: 1.2rem;
    font-weight: 600;
    color: #F09300;
}

.buy-section .book {
    display: flex;
    flex-direction: row;
    padding: 20px 0;
    margin: 10px 0 0px 0;
    border-bottom: 1px solid #E6E6E6;
}

.shop-section .price span {
    padding-left: 5px;
    text-decoration: line-through;
    color: #444444;
    font-weight: 100;
    font-size: 1rem;
}

.shop-section .shopcontent {
    display: flex;
    flex-direction: row;
}

.shop-section .content-section button {
    display: flex;
    margin-top: 0;
    font-size: 0.8rem;
    font-weight: 600;
    gap: 8px;
}

.pagination {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0;
}

.pagination .MuiPagination-ul {
    color: #667085 !important;
}

.pagination li:nth-child(n+2):nth-last-child(n+2) button {
    color: #667085;
}

.pagination li:first-child button,
.pagination li:last-child button {
    font-family: 'Sora', sans-serif;
    line-height: 20px;
    font-weight: 500;
    color: #344054;
    border: 1px solid #D0D5DD;
    gap: 10px;

}

.pagination li:first-child {
    position: absolute;
    left: 13lvw;
}

.pagination li:last-child {
    position: absolute;
    right: 13lvw;
}

.pagination .Mui-selected {
    background-color: #FCCC4D !important;
    /* Highlight color */
    color: #7F56D9 !important;
    /* Text color */
    font-weight: bold;
    /* Optional for better emphasis */
    border-radius: 50%;
    /* Optional: To make it more visually distinct */
}

@media (max-width: 768px) {

    .ebook .year-wise,
    .ebooks-one-year .month-wise {
        grid-template-columns: repeat(2, 1fr);
        /* 2 items per row on small screens */
    }
}

@media (max-width: 480px) {

    .ebook .year-wise,
    .ebooks-one-year .month-wise {
        grid-template-columns: 1fr;
        /* 1 item per row on very small screens */
    }
}

/* ...existing code... */

.monthlybook-buysection {
    background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
    border-radius: 24px;
    padding: 40px;
    margin: 20px 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.book-imagesection img {
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transition: transform 0.3s ease;
}

.book-imagesection img:hover {
    transform: scale(1.02);
}

.title-section .title {
    font-size: 2.5rem;
    font-weight: 700;
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 16px;
}

.subtext {
    background: rgba(240, 147, 0, 0.1);
    border-radius: 12px;
    padding: 12px 20px !important;
    margin: 16px 0;
}

.audio-section {
    background: #ffffff;
    border-radius: 16px;
    /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); */
    margin: 24px 0;
}

.audio-title-section button {
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    transition: transform 0.2s ease;
}

.audio-title-section button:hover {
    transform: translateY(-2px);
}

.audio-play-section {
    background: #ffffff;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.desc-info {
    background: #f8f9fa;
    border-radius: 20px;
    padding: 32px;
    /* margin: 32px 0; */
}

.desc-info-tabs button {
    font-size: 1.1rem;
    font-weight: 600;
    color: #666;
    transition: color 0.3s ease;
}


.other-ebooks {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 24px;
    padding: 32px 0;
}

.book-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 16px;
    transition: transform 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.book-card:hover {
    transform: translateY(-4px);
}

.book-card .text {
    font-size: 1rem;
    font-weight: 600;
    margin: 12px 0;
}

.book-card button {
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    transition: transform 0.2s ease;
}

.book-card button:hover {
    transform: scale(1.05);
}

/* Media Queries */
@media (max-width: 768px) {
    .monthlybook-buysection {
        flex-direction: column;
        padding: 24px;
    }

    .book-imagesection, 
    .book-contentsection {
        width: 100% !important;
    }

    .title-section .title {
        font-size: 2rem;
    }

    .other-ebooks {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
}

/* ...existing code... */

/* ...existing code... */

.desc-info {
    /* background: #ffffff; */
    border-radius: 24px;
    /* padding: 40px; */
    /* margin: 32px 0; */
    /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03); */
}

.desc-info-tabs {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-bottom: 24px;
    border-bottom: 1px solid #eee;
    padding-bottom: 16px;
}

.desc-info-tabs button {
    font-size: 1.1rem;
    font-weight: 600;
    color: #666;
    transition: all 0.3s ease;
    position: relative;
    padding: 8px 0;
    background: none;
}

.desc-info-tabs button::after {
    content: '';
    position: absolute;
    bottom: -17px;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.desc-info-tabs button.active {
    /* color: #F09300; */
    background: none;
}

.desc-info-tabs button.active::after {
    opacity: 1;
}

.desc-tab-content {
    padding: 24px 0;
}

.desc {
    font-size: 1rem;
    line-height: 1.8;
    color: #444;
    letter-spacing: 0.2px;
}

.desc p {
    margin-bottom: 16px;
}

.desc strong {
    color: #333;
    font-weight: 600;
}

.desc ul, .desc ol {
    padding-left: 24px;
    margin: 16px 0;
}

.desc li {
    margin-bottom: 8px;
}

.desc-info {
    animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .desc-info {
        padding: 24px;
        margin: 24px 0;
    }

    .desc-info-tabs {
        gap: 24px;
    }

    .desc-info-tabs button {
        font-size: 1rem;
    }

    .desc {
        font-size: 0.95rem;
        line-height: 1.7;
    }
}

/* ...existing code... */

/* Modern Year-wise Grid Layout */
.ebook .title {
    padding: 40px 0 24px;
    position: relative;
}
.ebooks-one-year .title{
    padding: 20px 0 24px;
    position: relative;
}

.ebook .title .emagazine
 {
    font-size: 1.5rem;
    font-weight: 800;
    background: #B54708;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
}

/* .ebook .title .emagazine::after {
    content: '';
    position: absolute;
    bottom: -16px;
    left: 0;
    width: 60px;
    height: 4px;
    background: #f09300;
    border-radius: 2px;
} */

.ebooks-one-year .title .emagazine {
    font-size: 1.2rem;
    font-weight: 800;
    background: #f09300;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
}

.ebooks-one-year .title .emagazine::after {
    content: '';
    position: absolute;
    bottom: -16px;
    left: 0;
    width: 60px;
    height: 4px;
    background: #f09300;
    border-radius: 2px;
}

.ebook .year-wise,
.ebooks-one-year .month-wise {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 32px;
    padding: 20px 0 40px;
    perspective: 1000px;
}

.ebook .year-wrapper, 
.ebooks-one-year .month-wrapper {
    position: relative;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05); */
    height: 300px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    transform-style: preserve-3d;
}

.ebook .year-wrapper:hover,
.ebooks-one-year .month-wrapper:hover {
    transform: translateY(-16px) rotateX(5deg);
    box-shadow: 0 20px 40px rgba(240, 168, 0, 0.166);
    border-radius: 10px;
}

.ebook .year-wrapper::before,
 .ebooks-one-year .month-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    height: 100%;
    background: linear-gradient(180deg, rgba(240, 168, 0, 0.148) 60%, rgba(240,168,0,0.5) 100%);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.ebook .year-wrapper:hover::before,
.ebooks-one-year .month-wrapper:hover::before {
    opacity: 1;
}

.ebook .year-wrapper img,
.ebooks-one-year .month-wrapper img {
    width: 80%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.5s ease;
}

.ebook .year-wrapper:hover img,
 .ebooks-one-year .month-wrapper:hover img {
    transform: scale(1.05);
}

.ebook .year-wrapper button,
 .ebooks-one-year .month-wrapper button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 40px);
    padding: 16px !important;
    /* background: rgba(255, 255, 255, 0.95); */
    border: none;
    border-radius: 12px;
    backdrop-filter: blur(8px);
    color: #000;
    font-size: 1.1rem;
    font-weight: 700;
    text-align: center;
    transition: all 0.3s ease;
    z-index: 2;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.ebook .year-wrapper button:hover,
 .ebooks-one-year .month-wrapper button:hover {
    background: #F09300;
   
    color: white;
    transform: translateX(-50%) translateY(-5px);
    box-shadow: 0 8px 25px rgba(43, 58, 103, 0.25);
}

/* Year Label */
.ebook .year-wrapper::after {
    content: attr(data-year);
    position: absolute;
    top: 20px;
    right: 20px;
    /* background: #f09300; */
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    padding: 8px 24px;
    border-radius: 30px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #121212;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    z-index: 2;
}

/* Month Label */
.ebooks-one-year .month-wrapper::after {
    content: attr(data-month);
    position: absolute;
    top: 20px;
    right: 20px;
    /* background: #f09300; */
    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);
    padding: 8px 24px;
    border-radius: 30px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #121212;
    backdrop-filter: blur(8px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    z-index: 2;
}

/* Responsive Adjustments */
@media (max-width: 1024px) {
    .ebook .year-wise,
    .ebooks-one-year .month-wise {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 24px;
    }
    
    .ebook .year-wrapper,
    .ebooks-one-year .month-wrapper {
        height: 350px;
    }
    
    .ebook .title .emagazine {
        font-size: 1rem;
    }
}

@media (max-width: 768px) {
    .ebook .year-wise,
    .ebooks-one-year .month-wise {
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        gap: 20px;
    }
    
    .ebook .year-wrapper, 
    .ebooks-one-year .month-wrapper {
        height: 200px;
    }
    
    .ebook .year-wrapper button,
    .ebooks-one-year .month-wrapper button {
        padding: 12px !important;
        font-size: 1rem;
    }
    
    .ebook .title .emagazine {
        font-size: 1.2rem;
    }
}

/* ...existing code... */`, "",{"version":3,"sources":["webpack://./src/pages/ebooks/ebooks.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,oBAAoB;IACpB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;;;IAII,oBAAoB;IACpB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;;IAGI,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,OAAO;IACP,uBAAuB;IACvB,gBAAgB;IAChB;QACI,sBAAsB;QACtB,mBAAmB;;IAEvB;AACJ;;AAEA;IACI,WAAW;IACX;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB;QACI,WAAW;QACX,mBAAmB;QACnB,eAAe;;IAEnB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI;QACI,eAAe;QACf,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;;AAElC;AACA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;;AAExB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;QACI,sBAAsB;QACtB,6BAA6B;;IAEjC;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB,EAAE,wCAAwC;IAC3D,gBAAgB,EAAE,2DAA2D;IAC7E,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;;IAEI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;;AAElB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,0FAA0F;AAC9F;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;;AAEZ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,SAAS;;AAEb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;;IAEI;;QAEI,qCAAqC;QACrC,qCAAqC;IACzC;AACJ;;AAEA;;IAEI;;QAEI,0BAA0B;QAC1B,yCAAyC;IAC7C;AACJ;;AAEA,wBAAwB;;AAExB;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4DAA4D;IAC5D,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,2BAA2B;AAC/B;;;AAGA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4DAA4D;IAChE;AACJ;;AAEA,wBAAwB;;AAExB,wBAAwB;;AAExB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,4DAA4D;IAC5D,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA,wBAAwB;;AAExB,iCAAiC;AACjC;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;IAC5D,iDAAiD;IACjD,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;;IAEI,0CAA0C;IAC1C,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,2FAA2F;IAC3F,UAAU;IACV,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,wBAAwB;IACxB,2CAA2C;IAC3C,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;;IAEI,mBAAmB;;IAEnB,YAAY;IACZ,4CAA4C;IAC5C,8CAA8C;AAClD;;AAEA,eAAe;AACf;IACI,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,4DAA4D;IAC5D,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,yCAAyC;IACzC,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,4DAA4D;IAC5D,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,yCAAyC;IACzC,UAAU;AACd;;AAEA,2BAA2B;AAC3B;IACI;;QAEI,4DAA4D;QAC5D,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,4DAA4D;QAC5D,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,wBAAwB;QACxB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,wBAAwB","sourcesContent":[".ebook .title,\n.shop-section .title {\n    padding: 20px 0;\n    display: flex;\n    flex-direction: row;\n    /* gap: 20px; */\n    justify-content: space-between;\n    font-size: 1.2rem;\n    font-weight: 600;\n    padding: 40px 0px 10px 0px;\n}\n\n.ebook .hdivider,\n.shop-section .hdivider,\n.otherbooks .hdivider {\n    transform: scaleY(0.5);\n}\n\n.ebook .year-wise,\n.ebooks-one-year .month-wise {\n    padding: 10px;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    /* 4 items per row */\n    gap: 30px;\n}\n\n.ebook .year-wrapper,\n.ebooks-one-year .month-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.ebook .year-wrapper img,\n.ebooks-one-year .month-wrapper img {\n    width: 9rem;\n    height: 10rem;\n    object-fit: cover;\n}\n\n.ebook .year-wrapper button,\n.ebooks-one-year .month-wrapper button {\n    margin: 0 !important;\n}\n\n.Year-navigation,\n.Month-navigation,\n.category-navigation,\n.home-navigation {\n    display: inline-flex;\n    gap: 5px;\n    padding: 10px 0;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.Month-navigation>.month,.year,\n.category-navigation>.nav-book,\n.home-navigation>.nav-title {\n    color: #D58C19;\n    font-weight: 600;\n}\n\n.monthlybook-buysection,\n.categorybook-buysection,\n.book-navigator {\n    display: flex;\n}\n\n.monthlybook-buysection,\n.categorybook-buysection {\n    gap: 20px;\n}\n\n.prev-next,\n.prev,\n.nxt {\n    display: inline-flex;\n}\n\n.prev,\n.nxt {\n    cursor: pointer;\n}\n\n.book-navigator {\n    justify-content: space-between;\n}\n\n.img-details-section {\n    display: flex;\n    align-items: flex-start;\n    gap: 3%;\n    justify-content: center;\n    margin-top: 1rem;\n    @media screen and (max-width: 430px) {\n        flex-direction: column;\n        align-items: center;\n        \n    }\n}\n\n.img-details-section img {\n    width: 25vw;\n    @media screen and (max-width: 430px) {\n        width: 100%;\n    }\n}\n\n.img-details-section>.details {\n    padding-top: 1rem;\n    width: 50%;\n    line-height: 1.7;\n    @media screen and (max-width: 430px) {\n        width: 100%;\n        text-align: justify;\n        font-size: 14px;\n        \n    }\n}\n\n.audio-section {\n    padding: 5%;\n    border: 1px solid #E7E7E7;\n    box-shadow: #000000;\n    /* box-shadow: 0px 4px 4px 0px #00000040; */\n}\n\n.audio-section>.audio-cat {\n    display: inline-flex;\n    /* background: #F09300; */\n    padding: 2px;\n    width: 5vw;\n    justify-content: flex-start;\n    font-size: 0.8rem;\n    color: #000000;\n    line-height: 20px;\n    width: 100%;\n}\n\n.audio-section>.audio-subtext {\n    display: flex;\n    justify-content: space-between;\n    color: #999999;\n    font-size: 0.8rem;\n    line-height: 20px;\n}\n\n.audio-section .views {\n    display: flex;\n    gap: 2px;\n}\n\n.audio-title-section {\n    padding: 10px 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.audio-title-section>.audio-title {\n    font-size: 2.2rem;\n    font-weight: 700;\n    line-height: 44px;\n    letter-spacing: -2px;\n}\n@media (max-width: 435px) {\n    .audio-title-section>.audio-title {\n        font-size: 1.1rem;\n        font-weight: 700;\n        line-height: 24px;\n        letter-spacing: -2px;\n    }\n}\n\n.audio-title-section button {\n    cursor: pointer;\n    padding: 0 15px;\n    border: none;\n    border-radius: 80px;\n    color: #ffffff;\n    font-weight: 700;\n    font-size: 0.8rem;\n    line-height: 44px;\n}\n@media (max-width: 435px){\n    .audio-title-section button {\n        cursor: pointer;\n        padding: 0 10px;\n        border: none;\n        border-radius: 80px;\n        color: #ffffff;\n        font-weight: 700;\n        font-size: 0.7rem;\n        line-height: 24px;\n    }\n}\n\n.audio-play-title {\n    display: inline-flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.audio-play-title>.index {\n    padding: 8px 12px;\n    /* border: 1px solid #000000; */\n    background: rgba(240, 170, 0, 0.5);\n    border-radius: 50px;\n    font-size: 1rem;\n    line-height: 1rem;\n    font-weight: 500;\n}\n@media (max-width: 435px){\n    .audio-play-title>.index{\n        padding: 5px 8px;\n        font-size: 0.7rem;\n        white-space: nowrap;\n    }\n}\n\n.audio-play-title p {\n    color: #11151F;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 16px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n\n}\n@media (max-width: 435px){\n    .audio-play-title p{\n        font-size: 12px;\n        line-height: 14px;\n    }\n}\n\n.audio-play-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-bottom: 30px;\n\n}\n\n.audio-play-section .player-transcript-section p {\n    background-color: #FFFFFF;\n}\n\n.audio-play-section .player {\n    /* border: 1px solid #ddd; */\n    border-radius: 10px;\n    padding: 20px;\n    max-width: 900px;\n    margin: 20px auto;\n    background-color: #fff;\n    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.audio-play-section .audio-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    @media screen and (max-width: 430px) {\n        flex-direction: column;\n        /* align-items: flex-start; */\n        \n    }\n}\n\n.audio-play-section .audio-image {\n    width: 100px;\n    height: 100px;\n    border-radius: 10px;\n    margin-right: 15px;\n}\n\n.audio-play-section .audio-details {\n    flex: 1;\n}\n\n.audio-play-section .audio-title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1rem;\n    color: #11151f;\n}\n\n.audio-play-section .audio-author {\n    margin: 5px 0 0;\n    font-size: 14px;\n    color: #555;\n}\n\n.audio-play-section .audio-element {\n    width: 100%;\n    margin: 10px 0;\n}\n\n.audio-play-section .audio-transcript {\n    font-size: 0.8rem;\n    line-height: 20px;\n    color: #000000;\n    font-weight: 400;\n    text-align: justify;\n    max-height: 200px; /* Set a max height for the transcript */\n    overflow-y: auto; /* Make it scrollable when the content exceeds the height */\n    padding-right: 10px;\n}\n\n.audio-prev-nxt {\n    display: flex;\n    justify-content: space-between;\n    border-width: 1px 0px 1px 0px;\n    border-style: solid;\n    border-color: #E6E6E6;\n    padding: 10px 0;\n}\n\n.audio-prev,\n.audio-nxt {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.audio-prev,\n.audio-nxt img {\n    max-width: 5vw;\n}\n\n.audio-prev-text,\n.audio-nxt-text {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.audio-nxt-text .nxt,\n.audio-prev-text .prev {\n    color: #999999;\n    font-weight: 400;\n    font-size: 0.8rem;\n    line-height: 20px;\n}\n\n.prev-title,\n.nxt-title {\n    color: #000000;\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.monthlybook-buysection>.book-imagesection,\n.categorybook-buysection>.book-imagesection {\n    width: 40%;\n}\n\n.monthlybook-buysection>.book-contentsection,\n.categorybook-buysection>.book-contentsection {\n    width: 50%;\n}\n\n.monthlybook-buysection>.book-imagesection img,\n.categorybook-buysection>.book-imagesection img {\n    width: 100%;\n}\n\n.prev-next {\n    gap: 10px;\n}\n.other-ebooks{\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    padding: 20px 0\n}\n\n.other-ebook-subtext,.comments-views, .other-book-desc{\n    color: #999999;\n    font-size: 0.8rem;\n    line-height: 14px;\n    font-weight: 400;\n}\n.other-book-desc{\n    padding-bottom: 10px;\n}\n.comments-views{\n    display: inline-flex;\n    gap: 2px;\n    align-items: center;\n}\n.comments-views> .comments, .comments-views>.views{\n    display: inline-flex;\n    gap: 2px;\n    align-items: center;\n}\n.other-book-title{\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 24px;\n    color: #000000;\n}\n.other-book-cat-read-more{\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #E6E6E6;\n    padding-top: 10px;\n}\n.other-book-cat{\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 13.66px;\n    text-align: left;\n}\n.other-book-cat span{\n    color:#f09300\n}\n.other-book-read-more{\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 12.29px;\n    text-align: left;\n    color: #000000;\n}\n\n\n.monthlybook-buysection .title-section,\n.categorybook-buysection .title-section {\n    padding-top: 15px;\n}\n\n.monthlybook-buysection .title,\n.categorybook-buysection .title {\n    font-size: 2rem;\n}\n\n.monthlybook-buysection .subtext,\n.categorybook-buysection .subtext {\n    padding: 10px 0;\n    font-size: 0.8rem;\n    gap: 20px;\n    border-bottom: 1px solid #E6E6E6;\n    font-weight: 100;\n}\n\n.monthlybook-buysection .subtext>.author,\n.categorybook-buysection .subtext>.author {\n    padding-right: 20px;\n    border-right: 1px solid #E6E6E6;\n}\n\n.book-contentsection .shortdesc {\n    padding: 15px 0;\n    color: #444444;\n    font-size: 0.8rem;\n    font-weight: 100;\n}\n\n\n.tabs,\n.buttons {\n    display: flex;\n    gap: 10px;\n    margin: 10px 0;\n}\n\n.buttons button {\n    font-size: 0.8rem;\n}\n\n.desc-info-tabs {\n    display: flex;\n    justify-content: start;\n    gap: 5lvw;\n}\n\n.desc-info-tabs>button {\n    font-size: 1.2rem;\n    border: none;\n}\n\n.tab-button,\n.desc-info-tabs .tab-underscore {\n    padding: 5px;\n    background-color: white;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 100;\n    line-height: 20px;\n}\n\n.tab-button {\n    border-radius: 10px;\n    border: 2px solid #ccc;\n}\n\n.tab-button.active {\n    color: #000000;\n    border-color: #F09300;\n}\n\n.tab-content {\n    margin-top: 20px;\n    border-radius: 10px;\n    width: 100%;\n    background-color: #f9f9f9;\n}\n\n.tab-content .hardcopy,\n.category-buy-section .tab-content {\n    font-size: 1rem;\n    font-weight: 400;\n}\n\n.audio-buy .plans {\n    font-size: 1rem;\n    padding-bottom: 15px;\n}\n\n.audio-buy .plans a {\n    color: #F09300;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.listen-copy-buy-section,\n.category-buy-section {\n    font-size: 0.8rem;\n    color: #444444;\n    font-weight: 100;\n}\n\n.subscribe-section {\n    border-width: 1px 0px 1px 0px;\n    border-style: solid;\n    border-color: #E6E6E6;\n    padding: 10px 0;\n}\n\n.subscribe-section button {\n    margin: 0 !important;\n}\n\n.cat-tag {\n    padding: 10px 0;\n    font-size: 0.6rem;\n    font-weight: 100;\n    line-height: 24px;\n}\n\n.month-selection,\n.year-selection {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.month-selection label,\n.year-selection label {\n    white-space: nowrap;\n    font-size: 1rem;\n    font-weight: 100;\n    line-height: 20px;\n}\n\n.month-selection input,\n.year-selection input {\n    width: 4rem;\n    padding: 0.4rem;\n    font-size: 1.2rem;\n    text-align: center;\n    border: 1px solid #E6E6E6;\n    border-radius: 50px;\n}\n\n.month-selection input[type=\"number\"]:hover,\n.year-selection input[type=\"number\"]:hover {\n    border-color: #007BFF;\n}\n\n.quantity-select {\n    padding: 10px 0;\n    display: flex;\n    align-items: flex-end;\n    gap: 20px;\n    border-width: 1px 0px 1px 0px;\n    border-style: solid;\n    border-color: #E6E6E6;\n}\n\n.quantity-select button {\n    margin: 0 !important;\n}\n\n.quantity-select .counter {\n    display: inline-flex;\n    gap: 20px;\n    font-size: 1rem;\n    border: 1px solid #E6E6E6;\n    border-radius: 50px;\n    padding: 10px;\n}\n\n.note {\n    font-size: 0.6rem;\n    padding-bottom: 10px;\n}\n\n.note span {\n    color: #E2401C;\n}\n\n.counter>.increase,\n.decrease {\n    cursor: pointer;\n}\n\n.tab-underscore.active {\n    color: #000000;\n    /* border-bottom: 2.5px solid #F09300; */\n}\n\n.desc-tab-content>* {\n    /* padding: 20px 10%; */\n    font-size: 0.8rem;\n    font-weight: 100;\n    color: #444444;\n    display: flex;\n    flex-wrap: wrap;\n    line-height: 24px;\n}\n\n.otherbooks-title {\n    display: flex;\n    gap: 50px;\n    color: #000000;\n\n}\n\n.otherbooks-title .hdivider {\n    color: #E6E6E6;\n}\n\n.otherbooks-title .text {\n    font-size: 1.4rem;\n    font-weight: 100;\n}\n\n.otherbooks-title .hdivider img {\n    width: 100%;\n    filter: invert(88%) sepia(11%) saturate(0%) hue-rotate(0deg) brightness(91%) contrast(93%);\n}\n\n.book-cards {\n    /* padding: 20px 0; */\n    display: flex;\n    gap: 20px;\n    flex-direction: row;\n    justify-content: flex-start;\n}\n\n.book-card,\n.cat-book-card {\n    width: 10vw;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n\n}\n\n.cat-book-card {\n    border-right: 1px solid #E6E6E6;\n}\n\n.book-card .text,\n.cat-book-card .text {\n    font-size: 0.7rem;\n    font-weight: 100;\n    line-height: 24px;\n    color: #000000;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    display: block;\n}\n\n.book-card img,\n.cat-book-card img {\n    width: 100%;\n}\n\n.book-card button,\n.cat-book-card button {\n    cursor: pointer;\n    border: none;\n    color: #F09300;\n    font-weight: 700;\n    font-size: 1.2rem;\n    background: none;\n    padding: 0;\n}\n\n.shop-section .genre {\n    flex: 1;\n}\n\n.shop-section .buy-section {\n    flex: 4;\n}\n\n.shop-section .genre .MuiCardContent-root {\n    display: flex;\n    font-size: 0.8rem;\n    flex-direction: column;\n    color: #0A0A0A;\n    gap: 30px;\n}\n\n.shop-section .categ {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.shop-section .categ .text {\n    color: #444444;\n    font-size: 0.8rem;\n    font-weight: 400;\n}\n\n.shop-section .categ {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.shop-section .categ input[type=\"checkbox\"] {\n    accent-color: black;\n}\n\n.shop-section .title {\n    color: #000000;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n\n.shop-section .content-section>* {\n    margin-bottom: 10px;\n}\n\n.shop-section .subtitle,\n.shop-section .desc {\n    font-size: 1rem;\n    font-weight: 100;\n    color: #444444;\n}\n\n.shop-section .price {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #F09300;\n}\n\n.buy-section .book {\n    display: flex;\n    flex-direction: row;\n    padding: 20px 0;\n    margin: 10px 0 0px 0;\n    border-bottom: 1px solid #E6E6E6;\n}\n\n.shop-section .price span {\n    padding-left: 5px;\n    text-decoration: line-through;\n    color: #444444;\n    font-weight: 100;\n    font-size: 1rem;\n}\n\n.shop-section .shopcontent {\n    display: flex;\n    flex-direction: row;\n}\n\n.shop-section .content-section button {\n    display: flex;\n    margin-top: 0;\n    font-size: 0.8rem;\n    font-weight: 600;\n    gap: 8px;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin: 1.5rem 0;\n}\n\n.pagination .MuiPagination-ul {\n    color: #667085 !important;\n}\n\n.pagination li:nth-child(n+2):nth-last-child(n+2) button {\n    color: #667085;\n}\n\n.pagination li:first-child button,\n.pagination li:last-child button {\n    font-family: 'Sora', sans-serif;\n    line-height: 20px;\n    font-weight: 500;\n    color: #344054;\n    border: 1px solid #D0D5DD;\n    gap: 10px;\n\n}\n\n.pagination li:first-child {\n    position: absolute;\n    left: 13lvw;\n}\n\n.pagination li:last-child {\n    position: absolute;\n    right: 13lvw;\n}\n\n.pagination .Mui-selected {\n    background-color: #FCCC4D !important;\n    /* Highlight color */\n    color: #7F56D9 !important;\n    /* Text color */\n    font-weight: bold;\n    /* Optional for better emphasis */\n    border-radius: 50%;\n    /* Optional: To make it more visually distinct */\n}\n\n@media (max-width: 768px) {\n\n    .ebook .year-wise,\n    .ebooks-one-year .month-wise {\n        grid-template-columns: repeat(2, 1fr);\n        /* 2 items per row on small screens */\n    }\n}\n\n@media (max-width: 480px) {\n\n    .ebook .year-wise,\n    .ebooks-one-year .month-wise {\n        grid-template-columns: 1fr;\n        /* 1 item per row on very small screens */\n    }\n}\n\n/* ...existing code... */\n\n.monthlybook-buysection {\n    background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);\n    border-radius: 24px;\n    padding: 40px;\n    margin: 20px 0;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n.book-imagesection img {\n    border-radius: 16px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    transition: transform 0.3s ease;\n}\n\n.book-imagesection img:hover {\n    transform: scale(1.02);\n}\n\n.title-section .title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    margin-bottom: 16px;\n}\n\n.subtext {\n    background: rgba(240, 147, 0, 0.1);\n    border-radius: 12px;\n    padding: 12px 20px !important;\n    margin: 16px 0;\n}\n\n.audio-section {\n    background: #ffffff;\n    border-radius: 16px;\n    /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); */\n    margin: 24px 0;\n}\n\n.audio-title-section button {\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    transition: transform 0.2s ease;\n}\n\n.audio-title-section button:hover {\n    transform: translateY(-2px);\n}\n\n.audio-play-section {\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);\n}\n\n.desc-info {\n    background: #f8f9fa;\n    border-radius: 20px;\n    padding: 32px;\n    /* margin: 32px 0; */\n}\n\n.desc-info-tabs button {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #666;\n    transition: color 0.3s ease;\n}\n\n\n.other-ebooks {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 24px;\n    padding: 32px 0;\n}\n\n.book-card {\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 16px;\n    transition: transform 0.3s ease;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n}\n\n.book-card:hover {\n    transform: translateY(-4px);\n}\n\n.book-card .text {\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 12px 0;\n}\n\n.book-card button {\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    color: white;\n    padding: 8px 16px;\n    border-radius: 20px;\n    font-size: 0.9rem;\n    transition: transform 0.2s ease;\n}\n\n.book-card button:hover {\n    transform: scale(1.05);\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n    .monthlybook-buysection {\n        flex-direction: column;\n        padding: 24px;\n    }\n\n    .book-imagesection, \n    .book-contentsection {\n        width: 100% !important;\n    }\n\n    .title-section .title {\n        font-size: 2rem;\n    }\n\n    .other-ebooks {\n        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    }\n}\n\n/* ...existing code... */\n\n/* ...existing code... */\n\n.desc-info {\n    /* background: #ffffff; */\n    border-radius: 24px;\n    /* padding: 40px; */\n    /* margin: 32px 0; */\n    /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03); */\n}\n\n.desc-info-tabs {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 16px;\n}\n\n.desc-info-tabs button {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #666;\n    transition: all 0.3s ease;\n    position: relative;\n    padding: 8px 0;\n    background: none;\n}\n\n.desc-info-tabs button::after {\n    content: '';\n    position: absolute;\n    bottom: -17px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.desc-info-tabs button.active {\n    /* color: #F09300; */\n    background: none;\n}\n\n.desc-info-tabs button.active::after {\n    opacity: 1;\n}\n\n.desc-tab-content {\n    padding: 24px 0;\n}\n\n.desc {\n    font-size: 1rem;\n    line-height: 1.8;\n    color: #444;\n    letter-spacing: 0.2px;\n}\n\n.desc p {\n    margin-bottom: 16px;\n}\n\n.desc strong {\n    color: #333;\n    font-weight: 600;\n}\n\n.desc ul, .desc ol {\n    padding-left: 24px;\n    margin: 16px 0;\n}\n\n.desc li {\n    margin-bottom: 8px;\n}\n\n.desc-info {\n    animation: fadeIn 0.5s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 768px) {\n    .desc-info {\n        padding: 24px;\n        margin: 24px 0;\n    }\n\n    .desc-info-tabs {\n        gap: 24px;\n    }\n\n    .desc-info-tabs button {\n        font-size: 1rem;\n    }\n\n    .desc {\n        font-size: 0.95rem;\n        line-height: 1.7;\n    }\n}\n\n/* ...existing code... */\n\n/* Modern Year-wise Grid Layout */\n.ebook .title {\n    padding: 40px 0 24px;\n    position: relative;\n}\n.ebooks-one-year .title{\n    padding: 20px 0 24px;\n    position: relative;\n}\n\n.ebook .title .emagazine\n {\n    font-size: 1.5rem;\n    font-weight: 800;\n    background: #B54708;\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n    display: inline-block;\n}\n\n/* .ebook .title .emagazine::after {\n    content: '';\n    position: absolute;\n    bottom: -16px;\n    left: 0;\n    width: 60px;\n    height: 4px;\n    background: #f09300;\n    border-radius: 2px;\n} */\n\n.ebooks-one-year .title .emagazine {\n    font-size: 1.2rem;\n    font-weight: 800;\n    background: #f09300;\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n    display: inline-block;\n}\n\n.ebooks-one-year .title .emagazine::after {\n    content: '';\n    position: absolute;\n    bottom: -16px;\n    left: 0;\n    width: 60px;\n    height: 4px;\n    background: #f09300;\n    border-radius: 2px;\n}\n\n.ebook .year-wise,\n.ebooks-one-year .month-wise {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 32px;\n    padding: 20px 0 40px;\n    perspective: 1000px;\n}\n\n.ebook .year-wrapper, \n.ebooks-one-year .month-wrapper {\n    position: relative;\n    background: #ffffff;\n    border-radius: 10px;\n    overflow: hidden;\n    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05); */\n    height: 300px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    transform-style: preserve-3d;\n}\n\n.ebook .year-wrapper:hover,\n.ebooks-one-year .month-wrapper:hover {\n    transform: translateY(-16px) rotateX(5deg);\n    box-shadow: 0 20px 40px rgba(240, 168, 0, 0.166);\n    border-radius: 10px;\n}\n\n.ebook .year-wrapper::before,\n .ebooks-one-year .month-wrapper::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    border-radius: 10px;\n    height: 100%;\n    background: linear-gradient(180deg, rgba(240, 168, 0, 0.148) 60%, rgba(240,168,0,0.5) 100%);\n    z-index: 1;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.ebook .year-wrapper:hover::before,\n.ebooks-one-year .month-wrapper:hover::before {\n    opacity: 1;\n}\n\n.ebook .year-wrapper img,\n.ebooks-one-year .month-wrapper img {\n    width: 80%;\n    height: 100%;\n    object-fit: contain;\n    transition: transform 0.5s ease;\n}\n\n.ebook .year-wrapper:hover img,\n .ebooks-one-year .month-wrapper:hover img {\n    transform: scale(1.05);\n}\n\n.ebook .year-wrapper button,\n .ebooks-one-year .month-wrapper button {\n    position: absolute;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: calc(100% - 40px);\n    padding: 16px !important;\n    /* background: rgba(255, 255, 255, 0.95); */\n    border: none;\n    border-radius: 12px;\n    backdrop-filter: blur(8px);\n    color: #000;\n    font-size: 1.1rem;\n    font-weight: 700;\n    text-align: center;\n    transition: all 0.3s ease;\n    z-index: 2;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.ebook .year-wrapper button:hover,\n .ebooks-one-year .month-wrapper button:hover {\n    background: #F09300;\n   \n    color: white;\n    transform: translateX(-50%) translateY(-5px);\n    box-shadow: 0 8px 25px rgba(43, 58, 103, 0.25);\n}\n\n/* Year Label */\n.ebook .year-wrapper::after {\n    content: attr(data-year);\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    /* background: #f09300; */\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    padding: 8px 24px;\n    border-radius: 30px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #121212;\n    backdrop-filter: blur(8px);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    z-index: 2;\n}\n\n/* Month Label */\n.ebooks-one-year .month-wrapper::after {\n    content: attr(data-month);\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    /* background: #f09300; */\n    background: linear-gradient(90deg, #F09300 0%, #FFB800 100%);\n    padding: 8px 24px;\n    border-radius: 30px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #121212;\n    backdrop-filter: blur(8px);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    z-index: 2;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1024px) {\n    .ebook .year-wise,\n    .ebooks-one-year .month-wise {\n        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n        gap: 24px;\n    }\n    \n    .ebook .year-wrapper,\n    .ebooks-one-year .month-wrapper {\n        height: 350px;\n    }\n    \n    .ebook .title .emagazine {\n        font-size: 1rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .ebook .year-wise,\n    .ebooks-one-year .month-wise {\n        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n        gap: 20px;\n    }\n    \n    .ebook .year-wrapper, \n    .ebooks-one-year .month-wrapper {\n        height: 200px;\n    }\n    \n    .ebook .year-wrapper button,\n    .ebooks-one-year .month-wrapper button {\n        padding: 12px !important;\n        font-size: 1rem;\n    }\n    \n    .ebook .title .emagazine {\n        font-size: 1.2rem;\n    }\n}\n\n/* ...existing code... */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
